export const ON_NEW_RUN = `
  subscription OnNewRun($organizationId: String!) {
    onNewRun(organizationId: $organizationId) {
      runSettings
      organizationId
      status
      createdAt
      updatedAt
      stepIds
      initiatedBy
      name
      description
      atStep
      totalSteps
      engineInProgress
    }
  }
`;
